var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPagination)?_c('div',{staticClass:"gl-pagination"},[_c('ul',{staticClass:"pagination clearfix"},_vm._l((_vm.getItems),function(item,index){return _c('li',{key:index,class:{
        page: item.page,
        'js-previous-button': item.prev,
        'js-next-button': item.next,
        'js-last-button': item.last,
        'js-first-button': item.first,
        separator: item.separator,
        active: item.active,
        disabled: item.disabled
      }},[_c('a',{on:{"click":function($event){$event.preventDefault();_vm.changePage(item.title, item.disabled)}}},[_vm._v("\n        "+_vm._s(item.title)+"\n      ")])])}))]):_vm._e()}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// /var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f62ca93a","hasScoped":false,"buble":{"transforms":{}}}!/var/cache/omnibus/src/gitlab-rails/node_modules/vue-loader/lib/selector.js?type=template&index=0!./vue_shared/components/table_pagination.vue
// module id = null
// module chunks = 